import { render, staticRenderFns } from "./ContestUserListView.vue?vue&type=template&id=560c601b&scoped=true&"
import script from "./ContestUserListView.vue?vue&type=script&lang=js&"
export * from "./ContestUserListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c601b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
